<template>

    <trax-ui-card :title="lang.polaris.dashboard.solo_session_information">
    
        <h6 class="section-title text-center py-2 mb-3" >
            Limitations
        </h6>

        <div class="row">
            <div class="col-xl-6">
                <p>
                    <strong>Visibility:</strong>
                    {{ visibility }}
                </p>
                <p>
                    <strong>Ceiling:</strong>
                    {{ ceiling }}
                </p>
                <p>
                    <strong>Max Crosswind:</strong>
                    {{ maxCrosswind }}
                </p>
            </div>
            <div class="col-xl-6">
                <p>
                    <strong>Max Effective Wind:</strong>
                    {{ maxEffectiveWind }}
                </p>
                <p>
                    <strong>Risk Assessment Score:</strong>
                    {{ riskAssessmentScore }}
                </p>
            </div>
        </div>

        <h6 class="section-title text-center py-2 mt-2 mb-3" >
            Type of Flight
        </h6>


        <div class="row">
            <div class="col-xl-6">
                <p>
                    <strong>Manoeuvrability:</strong>
                    {{ manoeuvrability }}
                </p>
                <p>
                    <strong>Cross Country:</strong>
                    {{ crossCountry }}
                </p>
            </div>
            <div class="col-xl-6">
                <p>
                    <strong>Night:</strong>
                    {{ night }}
                </p>
            </div>
        </div>

        <h6 class="section-title text-center py-2 mt-2 mb-3" >
            Work to be Completed
        </h6>

        <p class="mb-4" style="white-space:pre-wrap;">{{ workToBeCompleted }}</p>

        <h6 class="section-title text-center py-2 mt-2 mb-3" >
            Exercises Not Completed
        </h6>

        <p class="mb-4" style="white-space:pre-wrap;">{{ exercisesNotCompleted }}</p>

    </trax-ui-card>
</template>

<script>
    export default {
    
        data: function() {
            return {
                lang: lang,
                state: data.state
            }
        },
        
        computed: {

            visibility() {
                return this.state && this.state.visibility ? this.state.visibility : ''
            },

            ceiling() {
                return this.state && this.state.ceiling ? this.state.ceiling : ''
            },

            maxCrosswind() {
                return this.state && this.state.max_crosswind ? this.state.max_crosswind : ''
            },

            maxEffectiveWind() {
                return this.state && this.state.max_effective_wind ? this.state.max_effective_wind : ''
            },

            riskAssessmentScore() {
                return this.state && this.state.risk_assessment_score ? this.state.risk_assessment_score : ''
            },

            manoeuvrability() {
                return this.state && this.state.manoeuvrability ? 'Yes' : 'No'
            },

            crossCountry() {
                return this.state && this.state.cross_country ? 'Yes' : 'No'
            },

            night() {
                return this.state && this.state.night ? 'Yes' : 'No'
            },

            workToBeCompleted() {
                return this.state && this.state.work_to_be_completed ? this.state.work_to_be_completed : ''
            },

            exercisesNotCompleted() {
                return this.state && this.state.exercises_not_completed ? this.state.exercises_not_completed : ''
            },
        },
    }
</script>

<style scoped>

    .section-title {
        background-color: rgba(200,200,200,0.2);
    }

</style>